// White-label: el host puede mandar un mapa de variables de tema en el init.
// Se aplican como CSS custom properties sobre :root.
const ALLOWED = new Set([
  '--brand',
  '--brand-contrast',
  '--bg',
  '--surface',
  '--text',
  '--muted',
  '--border',
  '--radius',
]);

export function applyTheme(theme?: Record<string, string>) {
  if (!theme) return;
  const root = document.documentElement;
  for (const [key, value] of Object.entries(theme)) {
    const varName = key.startsWith('--') ? key : `--${key}`;
    if (ALLOWED.has(varName)) root.style.setProperty(varName, value);
  }
}
